export default {
  CourseDetail_click_play: '0702Web-點擊播放',
  CourseDetail_make_comment: '0707Web-參與評論',
  CourseDetail_Like_others_comments: '0709Web-點贊他人評論',
  CourseDetail_introduction_detail: '詳細介紹：',
  CourseDetail_handleUp_introduction: "收起詳細介紹",
  CourseDetail_starTip1: '很差，一分都嫌多',
  CourseDetail_starTip2: '很差，一分都嫌多',
  CourseDetail_starTip3: '一般，不太喜歡',
  CourseDetail_starTip4: '一般，不太喜歡',
  CourseDetail_starTip5: '還不錯',
  CourseDetail_starTip6: '還不錯',
  CourseDetail_starTip7: '很好，有收獲',
  CourseDetail_starTip8: '很好，有收獲',
  CourseDetail_starTip9: '非常棒，受益匪淺',
  CourseDetail_starTip10: '非常棒，受益匪淺',
  CourseDetail_resTime: '（{resTime}秒）',
  CourseDetail_exam: '考試',
  CourseDetail_pass: '通過',
  CourseDetail_noPass: '未通過',
  CourseDetail_courseRule1: '課程內全部課件已學',
  CourseDetail_courseRule2: '課程內任意課件已學',
  CourseDetail_examRule1: '需參加所有考試並及格',
  CourseDetail_examRule2: '需參加所有考試',
  CourseDetail_examRule3: '參加任意考試即可',
  CourseDetail_examRule4: '無需考試',
  CourseDetail_wearRule1: '純視頻/音頻課件：觀看/收聽完整內容',
  CourseDetail_wearRule2: '純視頻/音頻課件：觀看/收聽即算已學',
  CourseDetail_wearRule3: '圖文/混合/遊戲課件：觀看即算已學',
  CourseDetail_wearRule4: '電子書課件：閱讀進度達100%',
  CourseDetail_wearRule5: '圖文/混合/遊戲課件: 學習時長超過{value}分鐘',
  CourseDetail_wearRuleTips: '(含考試課件需考試及格)',
  CourseDetail_limitTime: '限{time}前完成',
  CourseDetail_courseComRule: '課程完成規則:',
  CourseDetail_wearComRule: '課件已學條件:',
  CourseDetail_examComRule: '考試完成條件:',
  CourseDetail_catalogue: '目錄',
  CourseDetail_comRule: '完成規則',
}
